import axios from "axios";

const state = {
    filter: 0,
    tree: [],
    treeLive: [],
};

const getters = {
    getTree(state) {
        return state.tree;
    },

    getFilter(state) {
        return state.filter;
    },

    getTreeLive(state) {
        return state.treeLive;
    },
};

function authHeaders(context) {
    return {
        headers: {
            Authorization: `Bearer ${context.rootGetters["settings/getToken"]}`,
        },
    };
}

const actions = {
    async setFilter(context, payload) {
        context.commit("SET_FILTER", payload);
    },

    async fetchTreeV2Complete(context, payload) {
        try {
            const language = context.rootGetters["settings/getLanguage"];
            const url = `${context.rootGetters["settings/getUrlApi"]}/v3/navigation/tree/v4/get-sports`;

            const res = await axios.post(
                url,
                {
                    filter: state.filter,
                    language: language,
                    platformId: context.rootGetters['settings/getPlatformId'],
                },
                authHeaders(context)
            );

            const tree = res.data.sports;
            const treeAntepost = res.data.sportsAntepost;

            tree.push({
                count: 0,
                icon_id: 9999,
                id: "9999#antepost",
                name: "Antepost",
                order: 9999,
                type: "antepost_root",
                typeOdds: "antepost",
                children: treeAntepost,
            });

            context.commit("setTree", tree);
        } catch (err) {
        }
    },

    async fetchCategoryTreeForSport(context, payload) {
        try {
            const language = context.rootGetters["settings/getLanguage"];
            const sportId = payload.sportId;

            const sportToFind = state.tree.find((sport) => sport.sportId === sportId);

            // Mantengo la tua logica: se non trovo sport o children già presenti, non carico
            if (!sportToFind) return;

            if (sportToFind.children == null || sportToFind.children.length === 0) {
                const url = `${context.rootGetters["settings/getUrlApi"]}/v3/navigation/tree/v4/get-category-for-sport`;

                const res = await axios.post(
                    url,
                    {
                        sportId,
                        filter: state.filter,
                        language,
                        platformId: context.rootGetters['settings/getPlatformId'],
                        sportName: sportToFind.name || undefined,
                    },
                    authHeaders(context)
                );

                if (res && res.data && res.data.categories) {
                    const categoriesTree = res.data.categories;
                    const saveTree = state.tree;

                    context.commit("setTree", []);

                    const sportToModify = saveTree.find((sport) => sport.icon_id === sportId);

                    if (sportToModify) {
                        sportToModify.children = categoriesTree;
                    }

                    context.commit("setTree", saveTree);
                }
            }
        } catch (err) {
        }
    },


    async fetchTournamentsTreeForCategoryV3(context, payload) {
        try {
            const language = context.rootGetters["settings/getLanguage"];
            const sportId = payload.sportId;
            const categoryId = payload.categoryId;

            const foundSport = state.tree.find((sport) => sport.sportId === sportId);
            if (!foundSport || !foundSport.children) return;

            const foundCategory = foundSport.children.find(
                (category) => category.categoryId === categoryId
            );
            if (!foundCategory) return;

            if (foundCategory.children == null || foundCategory.children.length === 0) {
                const url = `${context.rootGetters["settings/getUrlApi"]}/v3/navigation/tree/v4/get-tournaments-for-sport-category`;

                const res = await axios.post(
                    url,
                    {
                        sportId,
                        categoryId,
                        filter: state.filter,
                        language,
                        platformId: context.rootGetters['settings/getPlatformId'],
                        sportName: foundSport.name || undefined,
                        categoryName: foundCategory.name || undefined,
                    },
                    authHeaders(context)
                );

                if (res && res.data && res.data.tournaments) {
                    const saveTree = state.tree;
                    const treeTournaments = res.data.tournaments;

                    context.commit("setTree", []);

                    const sportToModify = saveTree.find((sport) => sport.icon_id === sportId);

                    if (sportToModify) {
                        const catToModify = sportToModify.children?.find(
                            (category) => category.categoryId === categoryId
                        );

                        if (catToModify != null) {
                            catToModify.children = treeTournaments;
                        }
                    }

                    context.commit("setTree", saveTree);
                }
            }
        } catch (err) {
        }
    },

    async fetchAntepostCategoryTreeForSportV3(context, payload) {
        try {
            const language = context.rootGetters["settings/getLanguage"];
            const sportId = payload.sportId;

            const antepostGroup = state.tree.find((sport) => sport.id === "9999#antepost");
            if (!antepostGroup || !antepostGroup.children) return;

            const sportGroup = antepostGroup.children.find((sport) => sport.sportId === sportId);
            if (!sportGroup) return;

            if (sportGroup.children == null || sportGroup.children.length === 0) {
                const url = `${context.rootGetters["settings/getUrlApi"]}/v3/navigation/tree/v4/get-category-for-sport-antepost`;

                const res = await axios.post(
                    url,
                    {
                        sportId,
                        filter: state.filter,
                        language,
                        platformId: context.rootGetters['settings/getPlatformId'],
                        sportName: sportGroup.name || undefined,
                    },
                    authHeaders(context)
                );

                if (res && res.data && res.data.categories) {
                    const categoriesTree = res.data.categories;
                    const saveTree = state.tree;

                    context.commit("setTree", []);

                    const sportToModify = antepostGroup.children.find((sport) => sport.icon_id === sportId);
                    if (sportToModify) {
                        sportToModify.children = categoriesTree;
                    }

                    context.commit("setTree", saveTree);
                }
            }
        } catch (err) {
        }
    },


    async fetchAntepostTournamentsTreeForSportV3(context, payload) {
        try {
            const sportId = payload.sportId;
            const categoryId = payload.categoryId;
            const language = context.rootGetters["settings/getLanguage"];

            const antepostGroup = state.tree.find((sport) => sport.id === "9999#antepost");
            if (!antepostGroup || !antepostGroup.children) return;

            const sportGroup = antepostGroup.children.find((sport) => sport.sportId === sportId);
            if (!sportGroup || !sportGroup.children) return;

            const categoryFound = sportGroup.children.find(
                (category) => category.categoryId === categoryId
            );
            if (!categoryFound) return;

            if (categoryFound.children == null || categoryFound.children.length === 0) {
                const url = `${context.rootGetters["settings/getUrlApi"]}/v3/navigation/tree/v4/get-tournaments-for-sport-category-antepost`;

                const res = await axios.post(
                    url,
                    {
                        sportId,
                        categoryId,
                        filter: state.filter,
                        language,
                        platformId: context.rootGetters['settings/getPlatformId'],
                        sportName: sportGroup.name || undefined,
                        categoryName: categoryFound.name || undefined,
                    },
                    authHeaders(context)
                );

                if (res && res.data && res.data.tournaments) {
                    const tournamentsTree = res.data.tournaments;
                    const saveTree = state.tree;

                    context.commit("setTree", []);

                    categoryFound.children = tournamentsTree;

                    context.commit("setTree", saveTree);
                }
            }
        } catch (err) {
        }
    },

    // ─── LIVE TREE ───────────────────────────────────────────────────────────

    async fetchTreeLiveComplete(context, payload) {
        try {
            const language = context.rootGetters["settings/getLanguage"];
            const url = `${context.rootGetters["settings/getUrlApi"]}/v3/navigation/tree/v4/live/get-sports`;

            const res = await axios.post(
                url,
                {
                    filter: state.filter,
                    language,
                    platformId: context.rootGetters["settings/getPlatformId"],
                },
                authHeaders(context)
            );

            const treeLive = res.data.sports;
            context.commit("setTreeLive", treeLive);
        } catch (err) {
        }
    },

    async fetchCategoryTreeLiveForSport(context, payload) {
        try {
            const language = context.rootGetters["settings/getLanguage"];
            const sportId = payload.sportId;

            const sportToFind = state.treeLive.find((sport) => sport.sportId === sportId);
            if (!sportToFind) return;

            if (sportToFind.children == null || sportToFind.children.length === 0) {
                const url = `${context.rootGetters["settings/getUrlApi"]}/v3/navigation/tree/v4/live/get-category-for-sport`;

                const res = await axios.post(
                    url,
                    {
                        sportId,
                        filter: state.filter,
                        language,
                        platformId: context.rootGetters["settings/getPlatformId"],
                        sportName: sportToFind.name || undefined,
                    },
                    authHeaders(context)
                );

                if (res && res.data && res.data.categories) {
                    const categoriesTree = res.data.categories;
                    const saveTree = state.treeLive;

                    context.commit("setTreeLive", []);

                    const sportToModify = saveTree.find((sport) => sport.icon_id === sportId);
                    if (sportToModify) {
                        sportToModify.children = categoriesTree;
                    }

                    context.commit("setTreeLive", saveTree);
                }
            }
        } catch (err) {
        }
    },

    async fetchTournamentsTreeLiveForCategory(context, payload) {
        try {
            const language = context.rootGetters["settings/getLanguage"];
            const sportId = payload.sportId;
            const categoryId = payload.categoryId;

            const foundSport = state.treeLive.find((sport) => sport.sportId === sportId);
            if (!foundSport || !foundSport.children) return;

            const foundCategory = foundSport.children.find(
                (category) => category.categoryId === categoryId
            );
            if (!foundCategory) return;

            if (foundCategory.children == null || foundCategory.children.length === 0) {
                const url = `${context.rootGetters["settings/getUrlApi"]}/v3/navigation/tree/v4/live/get-tournaments-for-sport-category`;

                const res = await axios.post(
                    url,
                    {
                        sportId,
                        categoryId,
                        filter: state.filter,
                        language,
                        platformId: context.rootGetters["settings/getPlatformId"],
                        sportName: foundSport.name || undefined,
                        categoryName: foundCategory.name || undefined,
                    },
                    authHeaders(context)
                );

                if (res && res.data && res.data.tournaments) {
                    const treeTournaments = res.data.tournaments;
                    const saveTree = state.treeLive;

                    context.commit("setTreeLive", []);

                    const sportToModify = saveTree.find((sport) => sport.icon_id === sportId);
                    if (sportToModify) {
                        const catToModify = sportToModify.children?.find(
                            (category) => category.categoryId === categoryId
                        );
                        if (catToModify != null) {
                            catToModify.children = treeTournaments;
                        }
                    }

                    context.commit("setTreeLive", saveTree);
                }
            }
        } catch (err) {
        }
    },

    // ─────────────────────────────────────────────────────────────────────────

    //TODO @deprecate will be deleted
    async findEventMin(context, payload) {
        try {
            const url = `${context.rootGetters["settings/getUrlApi"]}/events/findquickminv2`;

            if (payload.search != null && payload.search !== "") {
                const res = await axios.post(
                    url,
                    {
                        search: payload.search,
                        lang: payload.lang,
                        sport: payload.sport,
                    },
                    authHeaders(context)
                );

                if (res.data.events) {
                    return res.data.events;
                }
            }
        } catch (error) {
        }
    },

    //TODO @deprecate will be deleted
    async fetchMarketSportQuickbet(context, payload) {
        try {
            const url = `${context.rootGetters["settings/getUrlApi"]}/api/get-markets-sports-quickbet-event`;
            const res = await axios.post(url, payload, authHeaders(context));
            return res.data;
        } catch (err) {
        }
    },

    //TODO @deprecate will be deleted
    async fetchOutcomesByMarket(context, payload) {
        try {
            const url = `${context.rootGetters["settings/getUrlApi"]}/api/get-outcomes-market-event`;
            const res = await axios.post(url, payload, authHeaders(context));
            return res.data;
        } catch (err) {
        }
    },

    async fetchQbetMarketsV3(context, payload) {
        try {
            const url = `${context.rootGetters["settings/getUrlApi"]}/v3/agency/qbet-markets`;
            const res = await axios.post(
                url,
                {
                    platformId: String(context.rootGetters["settings/getPlatformId"]),
                    qbet: Number(payload.qbet),
                    lang: payload.lang,
                },
                authHeaders(context)
            );
            return res.data;
        } catch (err) {
        }
    },

    async fetchQuickbetOddsV3(context, payload) {
        try {
            const url = `${context.rootGetters["settings/getUrlApi"]}/v3/agency/quickbet-odds`;
            const res = await axios.post(
                url,
                {
                    platformId: String(context.rootGetters["settings/getPlatformId"]),
                    provider: payload.provider,
                    eventId: String(payload.eventId),
                    quickbet: payload.quickbet,
                    lang: payload.lang,
                },
                authHeaders(context)
            );
            return res.data;
        } catch (err) {
        }
    },
};

const mutations = {
    setTree(state, payload) {
        state.tree = payload;
    },

    setTreeLive(state, payload) {
        state.treeLive = payload;
    },

    SET_FILTER(state, payload) {
        state.filter = payload;
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions,
};
